import randomUtils from '@/utils/random.utils'

class BotStateUtils {

  static generateId(prefix = '') {
    return prefix + '_' + randomUtils.randomString(5)
  }

}

export default BotStateUtils
